import { VerticalContainer } from '@american-autonomy/ag-ui';

import BodyText from 'components/text/BodyText';
import CaptionText from 'components/text/CaptionText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ChemicalDetailWeather: FunctionComponent<Props> = ({
    testId = TEST_ID,
    title,
    weatherRestrictions
}) => (
    <VerticalContainer className={styles.weatherSection} testId={testId}>
        <BodyText className={styles.sectionTitle} text={title} />

        {weatherRestrictions.map(({ description, restrictionType }) => (
            <CaptionText key={restrictionType} text={`${restrictionType}: ${description}`} />
        ))}
    </VerticalContainer>
);

export default ChemicalDetailWeather;
